'use strict';

var component = angular.module('saturn.layout.nav.breadcrumbs', []);

var BreadcrumbsDirective = require('./BreadcrumbsDirective');
var BreadcrumbsController = require('./BreadcrumbsController');

component.directive('sbNavDrawerPageBreadcrumbs', [
  '$compile',
  BreadcrumbsDirective
]);

component.controller('sbNavDrawerBreadcrumbsController', [
  '$scope',
  'sbNavDrawerService',
  BreadcrumbsController
]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/breadcrumbs/index.js